import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Switch, Typography, Spin, Row, Col, Grid } from "antd";
import * as T from "utils/types";
import { SDGs } from "assets/svgs/SDG_icons";
import { SDGPanelThunks } from "./SDGPanelSlice";

export default () => {
  const dispatch = useDispatch();
  const SDGvec = useSelector((state: T.RootState) => state.SDGPanel.SDGvec);
  const status = useSelector((state: T.RootState) => state.SDGPanel.status);
  const errorMsg = useSelector((state: T.RootState) => state.SDGPanel.errorMsg);
  const screens = Grid.useBreakpoint();
  const breakpoint = screens.lg;

  useEffect(() => {
    if (status === "idle") {
      dispatch(SDGPanelThunks.rSDGvec());
    }
  }, [status, dispatch]);

  const imgHeight = 100;

  return (
    <div className="settingpage sub-heading-font">
      <Alert
        type="warning"
        message={
          <div style={{ padding: 16, fontSize: 16 }}>
            <p>
              <strong>
                Please select the Sustainable Development Goals (SDG) in which
                you are actively researching, or planning on doing so in the
                future.
              </strong>
            </p>
            <p>
              For more information about each SDG, please click on the SDG icon.
            </p>
          </div>
        }
      />
      <br />
      <Spin spinning={status === "loading"}>
        {status === "failed" && (
          <Typography.Text type="danger">
            {errorMsg} <br />
            Please refresh this page to get the correct data.
          </Typography.Text>
        )}
        <Row align="middle" gutter={{ xs: 0, sm: 4 }}>
          {SDGvec.map((status: boolean, index: number) => {
            //item:{icon:string, index:number, goal:string}
            const SDGitem = SDGs[index];
            return (
              <Col key={index} xs={{ span: 24 }} sm={{ span: 12 }}>
                <Row
                  key={index}
                  gutter={4}
                  justify="space-around"
                  align="middle"
                  style={{ marginBottom: 20 }}
                >
                  <Col span={10}>
                    <span>
                      <strong>{`SDG ${SDGitem.index} - ${SDGitem.goal}`}</strong>
                    </span>
                  </Col>
                  <Col span={4}>
                    <Switch
                      checked={status}
                      onClick={() => {
                        dispatch(
                          SDGPanelThunks.uSDGvec({
                            index: index,
                            status: !status,
                          })
                        );
                      }}
                    />
                  </Col>
                  <Col span={breakpoint ? 10 : "auto"}>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={SDGitem.url}
                    >
                      <img
                        src={SDGitem.icon}
                        alt={SDGitem.goal}
                        height={imgHeight}
                      />
                    </a>
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </Spin>
    </div>
  );
};
